import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const { Option } = Select;

function SelectLanguage({ className }) {

  const { i18n, t } = useTranslation();

  return (
    <Select
      className={className}
      value={i18n.language}
      onChange={(value) => i18n.changeLanguage(value)}
    >
      <Option value="es">{t('header.languages.spanish')}</Option>
      <Option value="en">{t('header.languages.english')}</Option>
    </Select>
  );

}

SelectLanguage.propTypes = {
  className: PropTypes.string,
};
SelectLanguage.defaultProps = {
  className: null,
};

export default SelectLanguage;
